import React from 'react'
import { Container, Header, Button } from 'semantic-ui-react'
import SubSub from '../../components/SubSub'

import Listing from '../Orders/Listing'
import Add from '../Orders/Add'

function Dashboard() {
    const handleLogout = () => {
        window.localStorage.removeItem('wp_user_auth');
        window.location.reload();
    }
    return (
        <Container style={{paddingTop:25}}>
            
            <Header as="h2" dividing style={{display:'flex', justifyContent:'space-between'}}>
                <Header.Content>Dashboard</Header.Content>
                
                <div>
                    <Button basic color='red' onClick={handleLogout}>Logout</Button>
                </div>
            </Header>


            <div style={{display:'flex'}}>
                <h2>Orders</h2> 
                <div><Add /></div>
            </div>

            <div style={{marginBottom: 10}}>
                <SubSub />
            </div>
                
            <div className="">
                <Listing />
            </div>
        </Container>
    )
}

export default Dashboard
